export class OrderShoppingCartDiscount {
    id: string;
    description: string;
    currencyCode: string;
    amount: number;
    percent: number;
}